import { useEffect, useState } from "react";
import { selectedOptic, userData } from "../js/utils";
import { post } from "../js/post";

export function useOphtalmologists() {
  const [list, setList] = useState([]);

  async function getData() {
    const response = await post("ListarOftalmologos.php", {
      token: userData.token,
      optica: selectedOptic.id,
    });
    setList(
      response.map((e) => ({
        id: e.id,
        text: e.nombreApellidos,
        licenseNumber: e.numeroColegiado,
      }))
    );
  }

  useEffect(() => {
    getData();
  }, []);

  return list;
}
